export default __webpack_public_path__ + "static/media/Wildhound Bracers.19beaaf9.jpg";